import { CertSimplified, ICertificate } from "../../interface/ICertificate";
import { IProfile } from "../../interface/IProfile";
import { useValidators } from "./validators.tsx";

const formatDate = (
    date: Date,
    format: String = 'dd.mm.yyyy'
) => {
    let day:string = String(date.getDate());
    let month:string = String(date.getMonth() + 1);
    let year:string = String(date.getFullYear());
    let hours:string = String(date.getHours());
    let minutes:string = String(date.getMinutes());
    let seconds:string = String(date.getSeconds());
    
    day = day.padStart(2, '0');
    month = month.padStart(2, '0');
    hours = hours.padStart(2, '0');
    minutes = minutes.padStart(2, '0');
    seconds = seconds.padStart(2, '0');

    let output = format.replace('dd',day);
    output = output.replace('mm',month);
    output = output.replace('yyyy',year);
    output = output.replace('hh',hours);
    output = output.replace('ii',minutes);
    output = output.replace('ss',seconds);
    
    return output;
};

const formatDateFromTimestamp = (timestamp:number|string, format: String = 'dd.mm.yyyy') => {
    let timestampString:String = String(timestamp);
    if (timestampString.length <= 10) {
        timestamp = Number(timestamp) * 1000;
    }
    let date = new Date(timestamp);
    return formatDate(date, format);
}

const formatCurrency = (number:number|string) => {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
        Number(number),
    )
}

const replaceByArray = (
    replaceValues:Array<string>, 
    replaceWith:string, string:string
) => {
    replaceValues.forEach((toReplace:string) => {
        string = string.replace(toReplace, replaceWith);
    })
    return string;
}

const sortCertificateArray = (certificateArray:Array<ICertificate|CertSimplified>) => {    
    let desiredCertificateOrder = ["CFP", "EFA", "CFEP", "CGA", "DIN-ISO 22222", "HonCFP", "HonCFEP"];
    certificateArray.sort((a:ICertificate|CertSimplified, b:ICertificate|CertSimplified) => {
        const indexA = desiredCertificateOrder.indexOf(a.type);
        const indexB = desiredCertificateOrder.indexOf(b.type);
        return indexA - indexB;
    });
    return certificateArray;
}

const sortCertificateStringArray = (certificateArray:Array<string>) => {    
    let desiredCertificateOrder = ["cfp", "efa", "cfep", "cga", "din-iso22222", "honcfp", "honcfep"];
    certificateArray.sort((a:string, b:string) => {
        const indexA = desiredCertificateOrder.indexOf(a);
        const indexB = desiredCertificateOrder.indexOf(b);
        return indexA - indexB;
    });
    return certificateArray;
}

const isBankingCertificate = (certificateType:string) => {    
    let bankingCertificiates = ["cfp", "CFP", "efa", "EFA", "cfep", "CFEP", "cga", "CGA", "din-iso22222", "DIN-ISO 22222", "fpsb emeritus", "FPSB Emeritus", "emeritus", "Emeritus"];
    return bankingCertificiates.includes(certificateType);
}

const checkProfileFieldsForErrors = (profile:IProfile, fieldsToCheck:Object) => {

    let errors:Object = {};
    Object.entries(fieldsToCheck).forEach(fieldName => {
        switch (fieldName[1]) {
            case 'text':
                if (!profile[fieldName[0]] || profile[fieldName[0]].length <= 0) {
                    errors[fieldName[0]] = 'Bitte füllen Sie dieses Feld aus';
                }
                break;
            case 'phone':
                let phoneValid = useValidators().validatePhone(profile[fieldName[0]], true, 'Telefonnummer');
                if (phoneValid !== true) {
                    errors[fieldName[0]] = phoneValid;
                }
                break;
            case 'email':
                let mailValid = useValidators().validateEmail(profile[fieldName[0]]);
                if (!mailValid) {
                    errors[fieldName[0]] = 'Bitte geben Sie eine gültige E-Mail-Adresse ein';
                }
                break;
            case 'url':
                let urlValid = useValidators().validateUrl(profile[fieldName[0]]);
                if (!urlValid) {
                    errors[fieldName[0]] = 'Bitte geben Sie eine gültige URL im Format http:// oder https:// ein.';
                }
                break;
            case 'linkedin':
                let linkedinValid = useValidators().validateLinkedinUrl(profile[fieldName[0]]);
                if (!linkedinValid) {
                    errors[fieldName[0]] = 'Bitte geben Sie eine gültige LinkedIn URL im Format http:// oder https:// ein.';
                }
                break;
            case 'iban':
                let ibanValid = useValidators().validateIban(profile[fieldName[0]]);
                if (!ibanValid) {
                    errors[fieldName[0]] = 'Bitte geben Sie eine gültige IBAN ein';
                }
                break;
            case 'bic':
                let bicValid = useValidators().validateBic(profile[fieldName[0]]);
                if (!bicValid) {
                    errors[fieldName[0]] = 'Bitte geben Sie eine gültige BIC ein';
                }
                break;
        }
    });
    return errors;
}

const moveItem = (data:any, item:any, targetKey:any) => {
    for (const key in data) {
        const index = data[key].indexOf(item);
        if (index !== -1) {
            data[key].splice(index, 1);
            if (data[key].length === 0) delete data[key];
            break;
        }
    }

    if (!data[targetKey]) {
        data[targetKey] = [];
    }

    if (!data[targetKey].includes(item)) {
        data[targetKey].push(item);
    }

    return data;
}

export const useHelper = () => {
    return { formatDate, formatDateFromTimestamp, formatCurrency, replaceByArray, sortCertificateArray, sortCertificateStringArray, isBankingCertificate, checkProfileFieldsForErrors, moveItem};
};
